var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-modal",rawName:"v-b-modal.receiptApproveModal",modifiers:{"receiptApproveModal":true}}],attrs:{"variant":"success","size":"sm"},on:{"click":_vm.setReceiptInfo}},[_c('i',{staticClass:"fas fa-check-circle mr-1"}),_vm._v(" Approve\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }